import React, {useState, useEffect} from 'react'
import {Col, Select} from "antd";
import Field from "../../ui/Field";
import weekendsAPI from "../../API/weekends";

const {Option} = Select

interface IProps {
  name?: string
  label?: string
  col?: {
    [key: string]: any
  }
}

export default (props: IProps) => {
  const {
    name = 'weekends',
    label = 'Search absence',
    col
  } = props;
  const [data, setData] = useState([]);

  const getData = async () => {
    try {
      const res = await weekendsAPI.get();
      setData(res.data.list);
    } catch (e) {
      return false
    }
  };

  const componentDidMount = () => {
    getData();
  };

  useEffect(componentDidMount, []);

  const getItem = () => {
    const itemComponent = <Field
      name={name}
      label={label}
    >
      <Select
        mode="multiple"
        maxTagCount={1}
        showSearch={true}
        notFoundContent="Not found"
        optionFilterProp="children"
      >
        {
          data.map((item: any, i: any) =>
            <Option
              value={item._id}
              key={i}>{item.name}</Option>)
        }
      </Select>
    </Field>;
    return col ? <Col {...col}>{itemComponent}</Col> : itemComponent
  }

  return data && data.length ? getItem() : null
}